import { useContext, useCallback } from 'react';
import { AppContext } from '../Translation/Context'
import { LOCALES } from '../Translation/i18nProvider/constants';

const BtnLanguage = () => {
    const { state, dispatch } = useContext(AppContext);

    const setLanguage = useCallback((locale) => {
        dispatch({
            type: 'setLocale',
            locale
        })
    }, []);

    if (state.locale === LOCALES.ENGLISH) {
  document.title = ("Misha Hubka")
} else if (state.locale === LOCALES.UKRAINE)
{
document.title = ("Міша Губка")
}

    return (
        <div className="button_lang">
               <p> <button disabled={state.locale === LOCALES.ENGLISH}
                    onClick={() => setLanguage(LOCALES.ENGLISH)}>En</button>
                    {/* <span className="buttonLang__line">|</span> */}
                <button disabled={state.locale === LOCALES.UKRAINE}
                    onClick={() => setLanguage(LOCALES.UKRAINE)}>Ua</button></p>
        </div>
    )
}

export default BtnLanguage;